/**
 * Created by vladislav on 18/05/2023
 */

const Exp = function (locationConfig) {
    cleverapps.EventEmitter.call(this);

    this.locationConfig = locationConfig;
    this.exp = 0;
};

Exp.prototype = Object.create(cleverapps.EventEmitter.prototype);
Exp.prototype.constructor = Exp;

Exp.prototype.destructor = function () {
    this.purge();
};

Exp.prototype.isAvailable = function () {
    return typeof match3 !== "undefined" && match3.heroes && match3.heroes.available() || ["merge", "merge2", "farm"].includes(cleverapps.config.type);
};

Exp.prototype.load = function (exp) {
    if (this.locationConfig) {
        this.exp = Math.floor(this.locationConfig.slot.load("exp")) || 0;
    } else {
        this.exp = Math.floor(exp) || 0;
    }
};

Exp.prototype.save = function () {
    if (this.locationConfig) {
        this.locationConfig.slot.save("exp", this.exp);
    } else {
        cleverapps.user.save();
    }
};

Exp.prototype.reset = function () {
    this.exp = 0;
    this.save();
};

Exp.prototype.getExp = function () {
    return this.exp;
};

Exp.prototype.setExp = function (exp, silent) {
    exp = Math.floor(exp);

    if (this.exp !== exp) {
        if (cleverapps.isNumber(this.exp) && !cleverapps.isNumber(exp)) {
            cleverapps.throwAsync(`Try set non number exp - ${exp}`);
            return;
        }

        this.exp = exp;
        this.save();

        if (!silent) {
            this.onChange();
        }
    }
};

Exp.prototype.onChange = function () {
    this.trigger("changeExp");
};

Exp.prototype.canTakeExp = function (exp) {
    return this.exp >= exp;
};

Exp.prototype.takeExp = function (exp, silent) {
    if (exp === 0) {
        return true;
    }

    if (this.canTakeExp(exp)) {
        this.setExp(this.exp - exp, silent);
        return true;
    }

    return false;
};
